import { BigNumber } from '@ethersproject/bignumber'
import { safeNumberToString } from './formatting'

const NUMBER_REGEX = /^\d*(\.\d*)?$/

export function bigNumberFromString(decimals: number, value: string) {
  value = value.replace(/,/g, '')
  if (!NUMBER_REGEX.test(value)) {
    throw new Error('Invalid value provided')
  }
  let [integer = '', decimal = ''] = value.split('.')
  if (integer === '') {
    integer = '0'
  }
  if (decimal.length < decimals) {
    decimal = decimal.padEnd(decimals, '0')
  } else if (decimal.length > decimals) {
    decimal = decimal.substring(0, decimals)
  }
  return BigNumber.from(integer.concat(decimal))
}

export function numberTo18Decimals(number: number) {
  return BigNumber.from(safeNumberToString(number * 10 ** 18))
}

export function bigNumberFromHex(hex: string) {
  return hex === '0x' ? BigNumber.from(0) : BigNumber.from(hex)
}
